import { useState, useRef, useEffect } from "react";
import { Sticker } from "lucide-react";
import zaloApi from "../../../../api/zaloApi";
import { useNotification } from "../../../../hooks/useNotification";

export function StickerPicker({ shopId, selectedChat }) {
  const [isOpen, setIsOpen] = useState(false);
  const { addNotification } = useNotification();
  const pickerRef = useRef(null);

  const stickerCates = ["Chào", "Ok", "Không", "Vui", "Buồn", "Mệt", "Chán"];

  const [stickers, setStickers] = useState([]);

  useEffect(() => {
    const fetchStickers = async () => {
      const newStickers = {};

      for (const cate of stickerCates) {
        try {
          const res = await zaloApi.getStickers({
            shopId,
            keyword: cate.toLowerCase(),
            count: 10,
          });
          newStickers[cate] = res.data;
        } catch (error) {
          console.error(`Error fetching ${cate} stickers:`, error);
        }
      }

      setStickers(newStickers);
    };

    fetchStickers();
  }, [shopId]);

  // Close picker when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSendSticker = (sticker) => {
    zaloApi
      .sendSticker({
        shopId: shopId,
        id: selectedChat.uid,
        isGroup: selectedChat.isGroup,
        sticker: JSON.stringify(sticker),
      })
      .then((res) => {
        if (res.status !== 1) addNotification(res.message, res.status);
      });
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={pickerRef}>
      <button
        className="p-1.5 rounded-md hover:bg-gray-200 transition-colors text-gray-500 hover:text-gray-700"
        onClick={() => setIsOpen(!isOpen)}
        title="Gửi Sticker"
        aria-label="Gửi Sticker"
      >
        <Sticker className="w-4 h-4" />
      </button>

      {isOpen && (
        <div className="absolute right-0 bottom-full mb-2 bg-white rounded-lg shadow-lg border border-gray-200 p-2 w-72 max-h-72 overflow-y-auto z-10">
          <div>
            {stickerCates.map((cate) => (
              <div key={cate} className="mb-4">
                <h2 className="font-bold mb-2">{cate}</h2>
                <div className="grid grid-cols-4 gap-2">
                  {stickers[cate]?.map((sticker, index) => (
                    <button
                      key={index}
                      className="flex items-center justify-center hover:bg-gray-100 rounded-md transition-colors"
                      onClick={() => handleSendSticker(sticker)}
                    >
                      <img src={sticker.stickerUrl} alt={`Sticker ${index}`} />
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
